// extracted by mini-css-extract-plugin
export default {"container":"DashboardDemographicsImage_container__fw84t","square_button":"DashboardDemographicsImage_square_button__Nw+Ie"};